/** RTE-X11.4a — read-only sequential stop ordering (no save/editor changes). */

let flagLogged = false;

/**
 * When unset: ON in development, OFF in production.
 * Set REACT_APP_SEQUENTIAL_STOPS_READ_MODE=true|false to override.
 */
export function isSequentialStopsReadModeEnabled(): boolean {
  const raw = process.env.REACT_APP_SEQUENTIAL_STOPS_READ_MODE;
  let enabled: boolean;
  if (raw === undefined || raw === '') {
    enabled = process.env.NODE_ENV === 'development';
  } else {
    enabled = String(raw).toLowerCase() === 'true';
  }
  if (process.env.NODE_ENV === 'development' && !flagLogged) {
    flagLogged = true;
    // eslint-disable-next-line no-console
    console.debug('[SequentialStopsRead] REACT_APP_SEQUENTIAL_STOPS_READ_MODE =', raw, '| enabled =', enabled);
  }
  return enabled;
}
